
import editBrandRedux from 'Modules/brands/views/.components/editBrand/redux/reducer';
import brandOverviewRedux from 'Modules/brands/views/overview/redux/reducer';
import createEditMessageTemplateRedux from 'Modules/brands/views/.components/createEditMessageTemplate/redux/reducer';
import deleteMessageTemplateRedux from 'Modules/brands/views/.components/deleteMessageTemplate/redux/reducer';
import deleteBrandRedux from 'Modules/brands/views/.components/deleteBrand/redux/reducer';

//export redux objects
export default {
	editBrandRedux,
	brandOverviewRedux,
	createEditMessageTemplateRedux,
	deleteMessageTemplateRedux,
	deleteBrandRedux,
};